<template>
  <HintDesktop v-if="message" class="show-for-medium" :message="message" />
</template>

<script>
import HintDesktop from './HintDesktop';

export default {
  components: {
    HintDesktop,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
